import { storeActions } from '@/store/actions'
import { MiddlewareType } from '@/store/middlewares/types'
import { ITracker } from '@/store/spi/tracker.ts'
import { CaseWorker, Organization } from '@/store/user'
import { PayloadAction } from '@reduxjs/toolkit'

const TO_BE_TRACKED_PATTERN = /^.*fulfilled$/

export const trackingMiddleware =
  (tracker: ITracker): MiddlewareType =>
  // @ts-expect-error not easy to type correctly
  () => {
    return (next) =>
      (
        action: PayloadAction<unknown> & {
          meta: { arg: Record<string, unknown> }
        },
      ) => {
        const newAction = next(action) // Required to be called at very first place

        switch (action.type) {
          case storeActions.initOrganization.fulfilled.type: {
            const payload = action.payload as {
              caseWorker: CaseWorker
              organization: Organization
            }
            tracker.identify({
              caseWorker: payload.caseWorker,
              organization: payload.organization,
            })
          }
        }

        if (TO_BE_TRACKED_PATTERN.test(action.type)) {
          tracker.track({ event: action.type })
        }
        return newAction
      }
  }
